import React from "react";
import Select from "react-select";
import { CSSObject } from "@emotion/react";

export type Option = {
  value: string;
  label: string;
  image_url?: string;
};

export interface SelectProps {
  options: Option[];
  value?: Option | Option[] | null;
  className?: string;
  onChange?: (option: Option | null) => void;
  isMulti?: boolean;
  isFullWidth?: boolean; 
  isOpenModalMargin?: boolean;
  isHeight?: boolean;
  isOpenModal?: boolean;
  placeholder?: string; 
  isDisabled?: boolean;
  forceFullWidth?: boolean;
}

const CommonSelect: React.FC<SelectProps> = ({
  options,
  value,
  className,
  onChange,
  isFullWidth = false,
  isOpenModalMargin = false,
  isHeight = true,
  isOpenModal = false,
  placeholder = "Select", // default if not passed
  isDisabled = false,
  isMulti = false,
  forceFullWidth
}) => {
  const path = window.location.pathname;
  const isInventoryPage = path.includes("/inventory");
  const isLeavePage = path.includes("/leave");
  const isEmployeePage = path.includes("/employees");
  const maxWidth = isInventoryPage ? 1586 : isLeavePage ? 554 : isEmployeePage? 554: 1054;
  const isMobile = window.innerWidth < maxWidth;
  const customStyles: Record<string, (provided: CSSObject, state: any) => CSSObject> = {
    container: (provided) => {
      // if forceFullWidth is true, span the full parent width
      return {
        ...provided,
        width: forceFullWidth ? "100%" : provided.width,
        minWidth: forceFullWidth ? "100%" : provided.minWidth,
        maxWidth: forceFullWidth ? "100%" : provided.maxWidth,
      };
    },
    control: (provided, state) => {
      const getShouldExpand = () => {
        const isResponsiveView =
          path.includes("/attendance-view/A") || path.includes("/employees") || path.includes("/leave") || path.includes("/inventory");
    
        return isMobile && isResponsiveView;
      };
     const isProfilePage = path.includes("/profile") || path.includes("/job-openings") || path.includes("/interviews");

  const height = isProfilePage ? "auto" : "32px";
      const shouldExpand = getShouldExpand();
      const width = forceFullWidth ? "100%" : shouldExpand ? "100%" : "150px";
    
      return {
        ...provided,
        width,
        minWidth: width,
        maxWidth: width,
        fontSize: "14px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: height,
        flexWrap: "wrap",
        height,
        marginLeft: forceFullWidth || shouldExpand ? "0px" : "20px",
        color: "#434A54",
        borderRadius: state.isFocused ? ".25rem" : provided.borderRadius,
        borderColor: state.isFocused ? "#80bdff" : provided.borderColor,
        boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(90, 82, 120, 0.25)" : "none",
        "&:hover": {
          borderColor: state.isFocused ? "#80bdff" : provided.borderColor,
        },
      };
    },    
    menu: (provided) => {
      const shouldExpand = forceFullWidth || (
        isMobile &&
        (path.includes("/attendance-view/A") || path.includes("/employees") || path.includes("/leave") || path.includes("/inventory"))
      );
      const width = shouldExpand ? "100%" : "150px";
    
      return {
        ...provided,
        width,
        minWidth: width,
        maxWidth: width,
        zIndex: 9999,
        fontSize: "14px",
        marginLeft: shouldExpand ? "0px" : "20px",
      };
    },
    
    menuList: (provided) => {
      const shouldExpand = forceFullWidth || (
        isMobile &&
        (path.includes("/attendance-view/A") || path.includes("/employees") || path.includes("/leave") || path.includes("/inventory"))
      );
      const width = shouldExpand ? "100%" : "150px";
    
      return {
        ...provided,
        maxHeight: "200px",
        overflowY: "auto",
        fontSize: "14px",
        width,
        minWidth: width,
        maxWidth: width,
      };
    },
    dropdownIndicator: (provided) => ({
      ...provided,
      marginTop: "-4px",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? "#5C7F9D" : state.isFocused ? "#5C7F9D" : "white",
      color: state.isSelected ? "white" : state.isFocused ? "white" : "#434A54",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#434A54",
    }),    
  };

  return (
    <Select
      classNamePrefix="react-select"
      className={className}
      options={options}
      value={value || null}
      onChange={onChange}
      styles={customStyles}
      placeholder={placeholder}
      isDisabled={isDisabled}
      isMulti={isMulti}
    />
  );
};

export default CommonSelect;